import { PendoIdentity } from '@types';

export const setPendoIdentify = (data: PendoIdentity) => {
	if ((window as any).pendo) {
		(window as any).pendo.identify(data);
	}
	if ((window as any).clarity && typeof (window as any).clarity === 'function') {
		if (data.visitor && data.visitor.id) {
			(window as any).clarity('identify', data.visitor.id);
		}
		if (data.account && data.account.company_name) {
			(window as any).clarity('set', 'company_name', data.account.company_name);
		}
		if (data.visitor && data.visitor.id) {
			(window as any).clarity('set', 'user_id', data.visitor.id);
		}
		if (data.visitor && data.visitor.role) {
			(window as any).clarity('set', 'user_role', data.visitor.role);
		}
		if (data.account && data.account.id) {
			(window as any).clarity('set', 'company_id', data.account.id);
		}
	}
}
